module.exports = __webpack_public_path__ + "2a499fcaadf48dfa7fecf6f2a6b92746.png";